module.exports = __webpack_public_path__ + "img/logo-mastercard.67083553.svg";